export {default} from './render-next-link';
